export const HANDLE_ERROR = 'error-handler/HANDLE_ERROR';
/* error - object from catch */
export const handleErrorAction = ({ error }) => ({
	type: HANDLE_ERROR,
	error,
});
